import { formatDateTime, formatCurrency } from "@/lib/hooks/utils";
import { CalculationNumberResponseDto } from "@/lib/interfaces/numbers";
import { Table, TableBody, TableCell, TableRow } from "@/ui-components/ui/table";
import { Dispatch, SetStateAction } from "react";
import NumbersEditor from "./numbers-editor";

const NumbersDetails = ({
  item,
  setReload,
  isEditing,
}: {
  item: CalculationNumberResponseDto;
  setReload: Dispatch<SetStateAction<boolean>>;
  isEditing: boolean;
}) => {
  return (
    <div>
      {isEditing ? (
        <div className="p-4 w-1/2 items-center m-auto">
          <NumbersEditor item={item} setReload={setReload} />
        </div>
      ) : (
        <div>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell className="font-medium">Kosten pro Lead</TableCell>
                <TableCell>{formatCurrency(item.costPerLead)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium">Eigener Lead Profit</TableCell>
                <TableCell>{formatCurrency(item.ownLeadProfit)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium">Zubehör Provision</TableCell>
                <TableCell>{item.accesoriesProvision}%</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium">Zuletzt bearbeitet</TableCell>
                <TableCell>{formatDateTime(item.updatedAt)}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
};

export default NumbersDetails;
